import React from 'react';
import { useSelector } from 'react-redux';
import chunk from 'lodash.chunk';
import { Grid } from 'semantic-ui-react';
import { AppState } from 'services/types';
import JobAttribute from './components/JobAttribute';
import { makeSelectSchemaAttributeIds } from './selectors';

interface Props {
    documentSetId: number; // eslint-disable-line
}

export default function JobAssessmentScores(props: Props): React.ReactElement {
    const { documentSetId } = props;
    const schemaAttributeIds = useSelector((state: AppState) =>
        makeSelectSchemaAttributeIds()(state, props)
    );

    const rowsLength = Math.ceil(schemaAttributeIds.length / 3);
    const schemaAttributeIdsChunked = chunk(schemaAttributeIds, rowsLength);

    const scores = (
        <Grid stackable relaxed columns={1} style={{ marginTop: '0px' }}>
            {schemaAttributeIdsChunked.map((ids: number[]) => (
                <Grid.Column
                    key={`${ids.join('-')}-${documentSetId}`}
                    style={{ paddingTop: '0px', paddingBottom: '0px' }}
                >
                    {ids.map((id: number) => (
                        <JobAttribute
                            key={`${id}-${documentSetId}`}
                            schemaAttributeId={id}
                            documentSetId={documentSetId}
                        />
                    ))}
                </Grid.Column>
            ))}
        </Grid>
    );

    return scores;
}
